import React from 'react'
import Main from 'components/Main'
import { GlobalStyle } from './components/styles/GlobalStyles'

export const App = () => {
  return (
    <>
      <GlobalStyle />
      <Main />
    </>
  )
}
